<template>
  <div :class="['metric-rating-group',isPKComp?'pk-comp':'']">
    <div class="ratings-content">
      <template v-if="isPKComp">
        <div class="rating-group school">
          <div class="description rating">This program</div>
          <VizFourBarRating class="small" :rating="schoolValue"/>
        </div>
        <div class="rating-group dist">
          <div class="description rating">District {{selectedSchoolDistrict}}</div>
          <VizFourBarRating class="small" :rating="distValue"/>
        </div>
      </template>
      <template v-else>
        <div v-for="d in ratingSlotData"
          :key="d.component_slot"
          class="rating-group"
        >
          <div v-if="d.display_text" class="description rating">{{d.display_text}}</div>
          <VizFourBarRating class="small" :rating="valueForSlot(d)"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'

import { NS_CURRENT_REPORT } from '../const'

import MetadataBase from './MetadataBase'
import VizFourBarRating from '@/components/VizFourBarRating'

/* Prefix (followed by number) for Valid Slot Names for this Component */
const SN_RATING_PREFIX = 'rating_value_'

/* Valid Slot Names for this Component */
const SN_DIST = 'dist_value'

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolDistrict'
    ])
  },
  components: {
    VizFourBarRating
  }
})
export default class MetricRatingGroup extends MetadataBase {
  isPKComp = false

  /* Getters */

  get ratingSlotData () {
    return this.slotDataForPrefix(SN_RATING_PREFIX)
  }
}

class MetricRatingGroupPkComp extends MetricRatingGroup {
  isPKComp = true

  /* Getters */
  get distValue () { return this.dispValueForSlotName(SN_DIST) }
}

export { MetricRatingGroup, MetricRatingGroupPkComp }

</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ratings-content {
  display: flex;
  flex-wrap: wrap;
  padding-top: 4px;
}
.rating-group {
  vertical-align: top;
  display: inline-block;
  margin-right: 24px;
  > * {
    display: inline-block;
  }
}
.description.rating {
  width: 140px;
  text-align: right;
  margin-right: 18px;
  margin-bottom: 0px;
}
.viz-four-bar-rating {
  width: 64px;
  height: 12px;
  vertical-align: top;
}

/* PK Comp-specific rules */
.metric-rating-group.pk-comp .rating-group.dist {
  color: #555555;
  .viz-four-bar-rating {
    border-color: #7a7a7a;
    /deep/ .bar.filled { fill: #7a7a7a; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/MetricRatingGroup.vue